import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useKanbanBoardStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            'gap': 16,
            'padding': 16,
            'display': 'flex',
            'width': 'max-content',
            'minWidth': '100%',
            'alignItems': 'flex-start',
            'boxSizing': 'border-box',
            'userSelect': 'none',
            '-webkit-user-select': 'none',

            [theme.breakpoints.up('sm')]: {
                gap: 24,
                padding: '8px 24px 12px'
            }
        }
    })
);
